import { render, staticRenderFns } from "./areaLayer.vue?vue&type=template&id=2ab9ccc2&scoped=true&"
import script from "./areaLayer.vue?vue&type=script&lang=js&"
export * from "./areaLayer.vue?vue&type=script&lang=js&"
import style0 from "./areaLayer.vue?vue&type=style&index=0&id=2ab9ccc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9ccc2",
  null
  
)

export default component.exports